import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

/**
 * BranchContext — provides the list of branches, the active branch,
 * and the list of doctors. Lives at the App root.
 */
const BranchContext = createContext({
  branches: [],
  doctors: [],
  activeBranch: null,
  setActiveBranch: () => {},
  refreshBranches: () => {},
  refreshDoctors: () => {},
});

export const BranchProvider = ({ API_BASE, children }) => {
  const [branches, setBranches] = useState([]);
  const [doctors, setDoctors]   = useState([]);
  const [activeBranch, setActiveBranchState] = useState(null);

  const refreshBranches = async () => {
    try {
      const r = await axios.get(`${API_BASE}/branches?active=true`);
      setBranches(r.data);
      // pick a default if none chosen yet
      if (r.data.length > 0) {
        const stored = localStorage.getItem('activeBranchId');
        const found  = stored ? r.data.find(b => b._id === stored) : null;
        const next   = found || r.data.find(b => b.isPrimary) || r.data[0];
        setActiveBranchState(next);
        if (next) localStorage.setItem('activeBranchId', next._id);
      }
    } catch (e) { /* silent */ }
  };

  const refreshDoctors = async () => {
    try {
      const r = await axios.get(`${API_BASE}/doctors?active=true`);
      setDoctors(r.data);
    } catch (e) { /* silent */ }
  };

  const setActiveBranch = (branch) => {
    setActiveBranchState(branch);
    if (branch) localStorage.setItem('activeBranchId', branch._id);
  };

  useEffect(() => {
    refreshBranches();
    refreshDoctors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BranchContext.Provider value={{ branches, doctors, activeBranch, setActiveBranch, refreshBranches, refreshDoctors }}>
      {children}
    </BranchContext.Provider>
  );
};

export const useBranch = () => useContext(BranchContext);
export default BranchContext;
